import Square from './Square.js'

export default Square
